export default function transformContactsToBorrower(contacts) {
  return contacts.map((c) => ({
    borrower: c.fullName || '',
    llc: c.llc || '',
    state: c.state.value || (typeof c.state === 'string' ? c.state : ''),
  }));
}

export const sanitizeNumericValueForPercentAndCurrency = (value) => {
  let val = '';

  if (value) {
    if (typeof value === 'string') {
      val = value.replace(/[^0-9.]/g, '');
    } else if (typeof value === 'number') {
      val = value.toString();
    }
  }

  if (val === '0' || val === 0) {
    val = '';
  }

  return val;
};
export const emptyRow = {
  address: '',
  country_code: '',
  current_market_value: '',
  group: '',
  id: '',
  key: '',
  lender_name: '',
  meta: '',
  mortgage_payment: '',
  municipality: '',
  ownership_percent: '',
  postal_code: '',
  premise: '',
  purchase_date: '',
  purchase_price: '',
  rehab_budget: '',
  rent_amount: '',
  sale_date: '',
  sale_price: '',
  state_code: '',
  state_name: '',
  title_name: '',
  total_mortgage_amount: '',
  type: '',
  _new: '',
};

export const REQUIRED_FIELDS_CONFIG = {
  fix_and_flips: [
    'address', 'titleName', 'ownershipPercent', 'purchaseDate',
    'purchasePrice', 'rehabBudget', 'salePrice', 'saleDate',
  ],
  new_construction: [
    'address', 'titleName', 'ownershipPercent', 'purchaseDate',
    'purchasePrice', 'rehabBudget', 'salePrice', 'saleDate',
  ],
  fix_and_rent: [
    'address', 'titleName', 'ownershipPercent', 'purchaseDate',
    'purchasePrice', 'rehabBudget', 'rentAmount',
  ],
  investment_properties_owned: [
    'address', 'titleName', 'ownershipPercent', 'purchaseDate', 'currentMarketValue',
    'lenderName', 'totalMortgageAmount', 'mortgagePayment', 'rentAmount', 'marketRent',
  ],
  primary_residence: ['address', 'titleName', 'ownershipPercent', 'purchaseDate', 'lenderName'],
};

export const GROUP_ENUM = {
  bridge: 'fix_and_flips',
  new_construction: 'new_construction',
  'bridge-rent': 'fix_and_rent',
  rental: 'investment_properties_owned',
  primary: 'primary_residence',
};

export const isRowAtLeastOneCellComplete = (row, fields) => fields.some((field) => {
  const value = row[field];

  return value !== undefined && value !== null && value !== '';
});

export const isRowIncomplete = (row, fields) => fields.some((field) => {
  const value = row[field];

  return value === undefined || value === null || value === '';
});

export const isRowFilled = (row, requiredFields) => requiredFields.every((field) => {
  const value = row[field];

  return value !== undefined && value !== null && value !== '';
});

export const GROUP_COLUMN_CONFIG = {
  bridge: 10,
  new_construction: 10,
  'bridge-rent': 8,
  rental: 11,
  primary: 8,
};

export const snakeToCamel = (str) => {
  if (!str || typeof str !== 'string') {
    return str;
  }

  return str.replace(/_([a-z])/g, (match, letter) => letter.toUpperCase());
};

export const requiredFields = (group) => {
  const fieldMap = {
    fix_and_flips: [
      'address',
      'titleName',
      'ownershipPercent',
      'purchaseDate',
      'purchasePrice',
      'rehabBudget',
      'salePrice',
      'saleDate',
    ],
    fix_and_rent: [
      'address',
      'titleName',
      'ownershipPercent',
      'purchaseDate',
      'purchasePrice',
      'rehabBudget',
      'rentAmount',
    ],
    new_construction: [
      'address',
      'titleName',
      'ownershipPercent',
      'purchaseDate',
      'purchasePrice',
      'rehabBudget',
      'salePrice',
      'saleDate',
    ],
    investment_properties_owned: [
      'address',
      'titleName',
      'ownershipPercent',
      'purchaseDate',
      'currentMarketValue',
      'lenderName',
      'totalMortgageAmount',
      'mortgagePayment',
      'rentAmount',
      'marketRent',
    ],
    primary_residence: [
      'address',
      'titleName',
      'ownershipPercent',
    ],
  };

  return fieldMap[group] || [];
};
